export class TecnicaDiagnostica {
    id: string;
    idTecnica: string;
    mtecnica: any;
    idValoracion: string;
    fechaIndicacion: string;
    fechaRealizacion: string;
    dnimedIndicacion: string;
    dnimedRealizacion: string;
    expediente: string;
    texto: string;
    viaAdministracion: string;
    numVisitaIndicacion: string;
    numVisitaRealizacion: string;
}



// WEBPACK FOOTER //
// ./src/models/tecnicadiagnostica.ts